namespace TabAurous.Retail {
    export namespace POSSalesLaborService {
        export const baseUrl = 'POSSales/POSSalesLabor';

        export declare function Create(request: Serenity.SaveRequest<POSSalesLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSSalesLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSSalesLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "POSSales/POSSalesLabor/Create",
            Update = "POSSales/POSSalesLabor/Update",
            Delete = "POSSales/POSSalesLabor/Delete",
            Retrieve = "POSSales/POSSalesLabor/Retrieve",
            List = "POSSales/POSSalesLabor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>POSSalesLaborService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
